// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  display: inline-block;
  position: relative;
  line-height: 22px;
  vertical-align: top;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.root select {
  position: relative;
  z-index: 2;
  display: inline-block;
  box-sizing: border-box;
  height: 30px;
  line-height: inherit;
  font-family: inherit;
  font-size: inherit;
  color: inherit;
  margin: 0;
  padding: 0;
  border: 4px solid transparent;
  border-right-width: 10px;
  border-left-width: 5px;
  background: none transparent;
  opacity: 0;
  cursor: pointer;
}

.root .value {
  display: block;
  position: absolute;
  z-index: 1;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  line-height: 23px;
  border: 1px solid #999;
  border-radius: 2px;
  padding: 3px;
  padding-right: 33px;
  padding-left: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.root .value::before,
.root .value::after {
  display: block;
  content: "";
  position: absolute;
  top: 50%;
  right: 10px;
  width: 0;
  height: 0;
  border: 4px solid transparent;
}

.root .value::before {
  margin-top: -10px;
  border-bottom-color: #555;
}

.root .value::after {
  margin-top: 1px;
  border-top-color: #555;
}

.root select:focus + .value {
  border-color: #66afe9;
}

/* On Webkit we can style <select> to be transparant without turning off the
   default focus styles. This is better for accessibility. */
@media screen and (-webkit-min-device-pixel-ratio:0) {
  .root select {
    opacity: 1;
    color: inherit;
    -webkit-appearance: none;
    border-left-width: 12px;
    border-right-width: 35px;
  }

  .root select + .value {
    color: transparent;
  }

  .root select:focus + .value {
    border-color: #999;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-rte/lib/ui/Dropdown.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,UAAU;EACV,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;EACtB,4BAA4B;EAC5B,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,MAAM;EACN,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,QAAQ;EACR,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;4DAC4D;AAC5D;EACE;IACE,UAAU;IACV,cAAc;IACd,wBAAwB;IACxB,uBAAuB;IACvB,wBAAwB;EAC1B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".root {\n  display: inline-block;\n  position: relative;\n  line-height: 22px;\n  vertical-align: top;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.root select {\n  position: relative;\n  z-index: 2;\n  display: inline-block;\n  box-sizing: border-box;\n  height: 30px;\n  line-height: inherit;\n  font-family: inherit;\n  font-size: inherit;\n  color: inherit;\n  margin: 0;\n  padding: 0;\n  border: 4px solid transparent;\n  border-right-width: 10px;\n  border-left-width: 5px;\n  background: none transparent;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.root .value {\n  display: block;\n  position: absolute;\n  z-index: 1;\n  left: 0;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  line-height: 23px;\n  border: 1px solid #999;\n  border-radius: 2px;\n  padding: 3px;\n  padding-right: 33px;\n  padding-left: 12px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.root .value::before,\n.root .value::after {\n  display: block;\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  width: 0;\n  height: 0;\n  border: 4px solid transparent;\n}\n\n.root .value::before {\n  margin-top: -10px;\n  border-bottom-color: #555;\n}\n\n.root .value::after {\n  margin-top: 1px;\n  border-top-color: #555;\n}\n\n.root select:focus + .value {\n  border-color: #66afe9;\n}\n\n/* On Webkit we can style <select> to be transparant without turning off the\n   default focus styles. This is better for accessibility. */\n@media screen and (-webkit-min-device-pixel-ratio:0) {\n  .root select {\n    opacity: 1;\n    color: inherit;\n    -webkit-appearance: none;\n    border-left-width: 12px;\n    border-right-width: 35px;\n  }\n\n  .root select + .value {\n    color: transparent;\n  }\n\n  .root select:focus + .value {\n    border-color: #999;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
